<template>
    <div style="height: 100%;">
        <router-view/>
        <van-tabbar v-model="active" :placeholder="true" :safe-area-inset-bottom="true">
            <van-tabbar-item replace to="/hairstaff" icon="manager-o">
                <span>我的客人</span>
            </van-tabbar-item>
            <van-tabbar-item replace to="/hairxflog" icon="manager-o" :badge="ccount">
                <span>消费日志</span>
            </van-tabbar-item>
            <van-tabbar-item replace to="/hairsalelog" icon="manager-o" :badge="salecount">
                <span>销售日志</span>
            </van-tabbar-item>
            <van-tabbar-item replace to="/staffdata" icon="bar-chart-o">
                <span>我的数据</span>
            </van-tabbar-item>
            <van-tabbar-item replace to="/hairwork" icon="bar-chart-o">
              <span>作品</span>
            </van-tabbar-item>
        </van-tabbar>
    </div>
    </template>
    <script>
        export default {
            data(){
                return {
                    active:0,
                    storeid:localStorage.getItem("storeid"),
                    staffid:localStorage.getItem("querystaffid"),
                    ccount:0,
                    salecount:0,
                }
            },
            created: function () {
                this.getStaffHairXfLogByStoreCount();
                this.getStaffHairSaleLogByStoreCount();
            },
            methods: {
                getStaffHairSaleLogByStoreCount(){
                    this.$post("hairmanager/getStaffHairSaleLogByStoreCount",{storeid:this.storeid,staffid:this.staffid}).then(res=>{
                        if(res.sucess){
                            this.salecount=res.object;
                        }
                        else{
                            this.$message({
                                message: res.message,
                                type: 'error'
                            });
                        }
                    });
                },
                getStaffHairXfLogByStoreCount(){
                    this.$post("hairmanager/getStaffHairXfLogByStoreCount",{storeid:this.storeid,staffid:this.staffid}).then(res=>{
                        if(res.sucess){
                            this.ccount=res.object;
                        }
                        else{
                            this.$message({
                                message: res.message,
                                type: 'error'
                            });
                        }
                    });
                }
            }
        }
    </script>



// WEBPACK FOOTER //
// src/page/manager/hairstafftabbar.vue